import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faDashboard, 
  faUsers, 
  faBell, 
  faCog, 
  faSignOutAlt,
  faBars,
  faTimes,
  faFilm,
  faServer,
  faTags,
  faChartLine,
  faImage,
  faExclamationTriangle,
  faToggleOn,
  faFileDownload,
  faUpload
} from '@fortawesome/free-solid-svg-icons';
import '../styles/AdminLayout.css';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

      const menuItems = [
      {
        path: '/admin',
        icon: faDashboard,
        label: 'Tổng quan',
        exact: true
      },
      {
        path: '/admin/movies',
        icon: faFilm,
        label: 'Quản lý phim'
      },
      {
        path: '/admin/movie-settings',
        icon: faToggleOn,
        label: 'Tùy chọn phim'
      },
      {
        path: '/admin/categories',
        icon: faTags,
        label: 'Thể loại'
      },
      {
        path: '/admin/status',
        icon: faChartLine,
        label: 'Trạng thái'
      },
      {
        path: '/admin/groups',
        icon: faUsers,
        label: 'Nhóm dịch'
      },
      {
        path: '/admin/covers',
        icon: faImage,
        label: 'Ảnh bìa'
      },
      {
        path: '/admin/reports',
        icon: faExclamationTriangle,
        label: 'Báo lỗi'
      },
      {
        path: '/admin/leech',
        icon: faFileDownload,
        label: 'Leech phim'
      },
      {
        path: '/admin/upload',
        icon: faUpload,
        label: 'Upload Video'
      },
      {
        path: '/admin/servers',
        icon: faServer,
        label: 'Quản lý Server'
      },
      {
        path: '/admin/members',
        icon: faUsers,
        label: 'Thành viên'
      },
      {
        path: '/admin/notifications',
        icon: faBell,
        label: 'Thông báo'
      },
      {
        path: '/admin/settings',
        icon: faCog,
        label: 'Thiết lập'
      }
    ];

  const handleLogout = () => {
    // TODO: Implement logout logic
    navigate('/');
  };

  const isActiveRoute = (path, exact = false) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <div className={`admin-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="admin-logo">
            <FontAwesomeIcon icon={faFilm} />
            <span>MAnime Admin</span>
          </div>
          <button 
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            <FontAwesomeIcon icon={sidebarOpen ? faTimes : faBars} />
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul>
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link 
                  to={item.path} 
                  className={isActiveRoute(item.path, item.exact) ? 'active' : ''}
                >
                  <FontAwesomeIcon icon={item.icon} />
                  <span>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <FontAwesomeIcon icon={faSignOutAlt} />
            <span>Đăng xuất</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className={`admin-main ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <header className="admin-header">
          <div className="header-left">
            <button 
              className="mobile-menu-toggle"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <FontAwesomeIcon icon={faBars} />
            </button>
            <h1>Quản lý MAnime</h1>
          </div>
          
          <div className="header-right">
            <div className="admin-user">
              <span>Xin chào, Admin</span>
            </div>
          </div>
        </header>

        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;